import { ADMINISTRATOR, FACULTY_ADMIN, UNIVERSITY_ADMIN, UNIVERSITY_SUPER_ADMIN, FACULTY, UNIVERSITY } from './roles';

export const getNumberedOptions = (min, max, incrementation = 1) => {
    let numberedOptions = [];

    for (let i = min; i <= max; i += incrementation) {
        numberedOptions = [...numberedOptions, {
            key: i,
            value: i,
            text: i.toString(),
        }];
    }

    numberedOptions.push({
        key: 0,
        value: 0,
        text: 'Sve',
    });

    return numberedOptions;
};

export const getTotalNumberOfPages = (total, resultsPerPage) => (
    Math.ceil(total / resultsPerPage)
);

export const DEFAULT_NUMBER_OF_ITEMS_PER_PAGE = 10;

export const checkFaculty = (activeRole) => (activeRole === FACULTY_ADMIN || activeRole === UNIVERSITY_SUPER_ADMIN || activeRole === FACULTY || activeRole.substr(0, 18) === FACULTY_ADMIN);

export const formatListForDropdownOptions = (list) => list.map(el => ({
    ...el, key: el.id, value: el.id, text: el.name
}));

export const checkOrganizationalUnitsPrivilege = (activeRole) => {
    if (!activeRole) activeRole = localStorage.getItem('activeRole');
    return activeRole === UNIVERSITY_SUPER_ADMIN || activeRole === UNIVERSITY_ADMIN || activeRole === ADMINISTRATOR;
};

export const checkWritePrivilege = (activeRole) => {
    if (!activeRole) activeRole = localStorage.getItem('activeRole');
    return activeRole.startsWith(FACULTY_ADMIN) || activeRole === UNIVERSITY_SUPER_ADMIN || activeRole === ADMINISTRATOR;
};

export const getLeaseholderName = (leaseholder) => {
    try {
        if (leaseholder.entityType.id === 1) {
            return (leaseholder.physicalEntity.firstName + ' ' + leaseholder.physicalEntity.lastName);
        } else if (leaseholder.entityType.id === 2) {
            return leaseholder.legalEntity.name;
        }
        return '-';
    } catch (err) {
        return '-';
    }
};



// WEBPACK FOOTER //
// ./src/views/Assets/util/util.js